import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import {
  PanelWrapper,
  PanelHeader,
  PanelContent,
  PanelActions,
  Address,
  ContactNumber,
  ButtonColorWrapper,
  ActionButton2
} from './HomePage.style';

const GetInTouchPanel = ({
  headerColor,
  renderTradeShowButton,
  restaurant
}) => {
  const {contactNumber, address} = restaurant;
  const telephoneToUrl = `tel:${contactNumber}`;
  const title = restaurant.content && restaurant.content.inTouchSectionTitle || <FormattedMessage id="home.getInTouch.title" />;

  return (
    <PanelWrapper getInTouchPanel={true}>
      <PanelHeader headerColor={headerColor}>{title}</PanelHeader>
      <PanelContent data-rw="home-page--restaurant-info">
        <Address data-rw="home-page--restaurant-content-address">{address.singleLine}</Address>
        <FormattedMessage id="contact.tel" />
        <ContactNumber
          href={telephoneToUrl}
          data-rw="home-page--restaurant-phone-number"
          headerColor={headerColor}
        >
          {contactNumber}
        </ContactNumber>
      </PanelContent>
      <PanelActions>
        <ButtonColorWrapper headerColor={headerColor}>
          {renderTradeShowButton}
        </ButtonColorWrapper>
        <ActionButton2
          to="/contact"
          data-rw="home-page--contact-us-link"
        >
          <FormattedMessage id="home.getInTouch.openingTime" />
        </ActionButton2>
      </PanelActions>
    </PanelWrapper>
  );
};

GetInTouchPanel.propTypes = {
  headerColor: PropTypes.string.isRequired,
  renderTradeShowButton: PropTypes.func.isRequired,
  restaurant: PropTypes.object.isRequired
};

export default GetInTouchPanel;



// WEBPACK FOOTER //
// ./containers/HomePage/GetInTouchPanel.js